import { createStore } from "vuex";

import rootMutations from "./rootMutations.js";
import rootGetters from "./rootGetters.js";
import rootActions from "./rootActions.js";

import gamerDataModule from './modules/gamerData/index.js';

export default createStore({
  modules:{
        gamer : gamerDataModule
  },
  state() {
    return {
      profitView: true,
      selectedCurrency: "pound",
      currencyRate: {
        pound: 0.72,
        euro: 0.85,
        dollar: 1.00,
      },
      currencySymbol:{
        pound: '£',
        euro: "€",
        dollar: '$'
      },
      timer: 0,
      timeUnits: "MINUTES",
      timeConversion: {
        SECONDS: 1,
        MINUTES: 60,
        HOURS: 3600,
        DAYS: 86400,
      },
      gameCategory:"ALL",
    };
  },
  mutations: rootMutations,
  getters: rootGetters,
  actions: rootActions,
});
